import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Checkbox, Flex, P } from 'ui/acro'

const BooleanToggle = ({
  disabled,
  handleSelect,
  prompt,
  selected,
  slug,
  ...rest
}) => {
  const [hovered, setHovered] = useState()

  return (
    <Flex
      as='label'
      htmlFor={`${slug}-switch`}
      alignItems='center'
      onClick={!disabled && handleSelect}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      cursor='pointer'
      mr='auto'
      {...rest}
    >
      <Checkbox
        mr='16px'
        height={['24px']}
        width={['24px']}
        selected={selected}
        hovered={hovered}
        disabled={disabled}
      />
      <P as='span'>{prompt}</P>
    </Flex>
  )
}
BooleanToggle.propTypes = {
  disabled: PropTypes.bool,
  handleSelect: PropTypes.func.isRequired,
  prompt: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  slug: PropTypes.string.isRequired
}

export default BooleanToggle
